import { ROWS } from "../components/jungle/JSchedule";

// Genetics presets: growth weeks (vegetative) and flowering weeks.
export const GENETICS = {
  indica: { label: "Índica dominante", growth: 3, flower: 8, auto: false, note: "Floración corta y compacta. Coincide con el cuadrante oficial (11 semanas)." },
  hibrida: { label: "Híbrida", growth: 3, flower: 9, auto: false, note: "Equilibrio entre producción y tiempo." },
  sativa: { label: "Sativa dominante", growth: 3, flower: 11, auto: false, note: "Floración larga, mucho estirón." },
  auto: { label: "Autofloreciente", growth: 3, flower: 7, auto: true, note: "Florece sola, sin cambio de fotoperiodo." },
};

const MID = ["F3", "F4", "F5", "F6", "F7"];

// Map plan weeks onto the Jungle table columns (C1…C3, F1…F8 lavado). Longer flowering repeats F3…F7.
export const planColumns = (growth, flower) => {
  const g = Array.from({ length: growth }, (_, i) => ["C1", "C2", "C3"][Math.min(i, 2)]);
  const m = Math.max(flower - 3, 0);
  const mid = Array.from({ length: m }, (_, i) => MID[Math.floor((i * MID.length) / m)]);
  return [...g, "F1", "F2", ...mid, "F8"].slice(0, growth + flower);
};

const addDays = (d, n) => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n);
export const parseDate = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};

const tasksFor = ({ col, i, growth, flower, auto }) => {
  const t = [];
  const fw = i - growth + 1; // flowering week number (1-based)
  if (i === 0) t.push(auto ? "Germinación / plántula: riegos pequeños alrededor del tallo" : "Plántula o esqueje enraizado: riegos pequeños");
  if (i === growth - 1 && !auto) t.push("Última semana de crecimiento: prepara el cambio a 12/12");
  if (fw === 1) t.push(auto ? "Empieza la floración sola: entra A Bloom" : "Cambia el fotoperiodo a 12/12 h y empieza A Bloom");
  if (fw === 2) t.push("Estirón: entutora y deja espacio hasta la luz");
  if (fw === 3) t.push("Entran B Bloom, PK y Bongo Bloom: añade primero B Bloom");
  if (col === "F8") t.push("Lavado: riega solo con agua y revisa tricomas para cosechar");
  if (i >= growth && fw > 3 && col !== "F8") t.push("Humedad por debajo del 50 % y revisa hongos");
  if (i < growth && i > 0) t.push("Revisa pH y drenaje (10–20 %)");
  return t;
};

export const buildPlan = ({ start, genetic, growth, flower }) => {
  const s = parseDate(start);
  const auto = GENETICS[genetic]?.auto ?? false;
  const cols = planColumns(growth, flower);
  const weeks = cols.map((col, i) => {
    const doses = ROWS.filter(([, , , d]) => d?.[col]).map(([id, name, img, d]) => ({ id, name, img, dose: d[col] }));
    return {
      n: i + 1, col, from: addDays(s, i * 7), to: addDays(s, i * 7 + 6),
      phase: col.startsWith("C") ? "Crecimiento" : "Floración",
      label: col.startsWith("C") ? `Crecimiento S${i + 1}` : col === "F8" ? "Lavado" : `Floración S${i - growth + 1}`,
      doses, tasks: tasksFor({ col, i, growth, flower, auto }),
    };
  });
  const flip = addDays(s, growth * 7);
  const harvest = addDays(s, (growth + flower) * 7);
  const bWeek = weeks.find((w) => w.col === "F3");
  const flush = weeks.find((w) => w.col === "F8");
  return {
    weeks, flip, harvest, total: growth + flower,
    milestones: [
      ["Inicio", s],
      [auto ? "Empieza a florecer" : "Cambio a 12/12", flip],
      ["Entran B Bloom + PK", bWeek?.from],
      ["Lavado (solo agua)", flush?.from],
      ["Cosecha estimada", harvest],
    ].filter(([, d]) => d),
  };
};

export const currentWeekIndex = (plan, today = new Date()) => {
  const t = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  return plan.weeks.findIndex((w) => t >= w.from && t <= w.to);
};

export const fmtDate = (d, opts = { day: "numeric", month: "short" }) => d.toLocaleDateString("es-ES", opts);
